<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Your Contribution">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <FormRow inline class="ticket">
              <div class="singleTicket">
                <FormLabel>
                  Single Ticket {{ isEarlyBird ? '(Early Bird)' : '' }}:
		              <MoneyFormat class="label-amount" :value="ticketPrice" :currencyCode="form.currency || 'USD'" :hide-subunits="true" />
	              </FormLabel>
              </div>
            </FormRow>
            <FormRow>
               <FormLabel>
                <input
                  type="checkbox"
                  id="soldier"
                  name="soldier"
                  :checked="soldier"
                  @click="soldier = $event.target.checked"
                />
                I would like to help cover the cost of a serving soldier at the party
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Your Details">
            <FormRow v-if="form.currency == 'ILS'" inline class="israeli-tax-id-row">
              <FormCol field="taxId" label="Teudat Zehut" placeholder="Enter your Teudat Zehut" />
            </FormRow>
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Summary">
            <FormRow>
              <div class="summary">
                <table>
                  <tr v-if="initialAmount && initialAmount > 0">
                    <td>Single Ticket:</td>
                    <td><MoneyFormat :value="initialAmount" :currencyCode="form.currency || 'USD'" :hide-subunits="true" /></td>
                  </tr>
                  <tr v-if="soldierAmount && soldierAmount > 0">
                    <td>Soldier Ticket:</td>
                    <td><MoneyFormat :value="soldierAmount" :currencyCode="form.currency || 'USD'" :hide-subunits="true" /></td>
                  </tr>
                  <tr class="total">
                    <td>Total:</td>
                    <td>
                      <span class="currency-symbol" v-html="form.currency == 'ILS' ? '₪' : '$'"></span>{{ form.amount }}
                    </td>
                  </tr>
                </table>
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="Payment Information" last>
            <!-- <FormRow>
              <Receipt :receipts="['us', 'israel']"/>
            </FormRow> -->
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton btnText="Donate" showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  type PropType,
  ref,
  watch,
  nextTick
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

import type { Currency } from "~/form-settings";

export default defineComponent({  setup(props) {
    const { getValue, settings, setValue, form } = usePaymentForm();

    const currency = ref(form.value.currency);

    // Check if current date is before December 12, 2025
    const earlyBirdDeadline = new Date('2025-12-12T23:59:59');
    const isEarlyBird = ref(new Date() < earlyBirdDeadline);

    // Calculate ticket price based on currency and early bird status
    const ticketPrice = computed(() => {
      const currentCurrency = form.value.currency || 'ILS';
      if (isEarlyBird.value) {
        return currentCurrency === 'USD' ? 30 : 100;
      } else {
        return currentCurrency === 'USD' ? 46 : 150;
      }
    });

    const initialAmount = ref(ticketPrice.value);
    const soldierAmount = ref(0);
    const soldier = ref(false)

    onMounted(() => {
      const price = ticketPrice.value;
      setValue('amount', String(price))
      initialAmount.value = price
    })

    watch(() => form.value.currency, () => {
      const price = ticketPrice.value;
      setValue('amount', String(price))
      soldierAmount.value = 0
      initialAmount.value = price
      soldier.value = false
    })

      watch(() => getValue('currency'), () => {
      if (getValue('currency') == 'ILS') {
        setValue('gateway','SensepassCardcomPrograms')
      } else{
        setValue('gateway','SensepassCardknoxOUSpec')
      }
    });

    watch(soldier, async () => {
      if (soldier.value) {
        soldierAmount.value = initialAmount.value
      } else {
        soldierAmount.value = 0
      }
      await nextTick();
      setValue('amount', String(initialAmount.value + soldierAmount.value))
    })

    return {
      form,
      setValue,
      getValue,
      currency,
      initialAmount,
      soldier,
      soldierAmount,
      isEarlyBird,
      ticketPrice,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
::v-deep h2 {
  font-size: 26px;
  line-height: 1.2;
  font-weight: 200;
  text-transform: none;
  position: relative;
  letter-spacing: 0px;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

label.label__lg {
  display: block;
  padding-bottom: 5px;
  background: inherit;
  color: inherit;
  text-align: left;
  border: none;
}
.ticket {
  gap: 10px;
  max-width: 400px;
  ::v-deep .currency-selector {
    flex: 0
  }
}
.singleTicket ::v-deep label {
  padding: 15px;
  border: 1px solid #ddd;
  font-weight: bold;
  background: #15329d;
  margin: 0;
  color: white;
  width: 100%;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: block;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.styled-radio--ou-donation  .amount_other__wrapper {
  position: relative;
  margin-bottom: 10px;
  margin-right: 0;
  min-width: 16.6%;
  max-width: 31.6%;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding-left: 5px;
  flex: 1;
  line-height: 1;
  @media (max-width: 720px) {
    margin-right: 5px;
    margin-left: 5px;
    margin-bottom: 10px;
  }
  &:before {
    content: '$';
    position: absolute;
    padding: 15px 8px;
    border-right: 1px solid #ddd;
    height: 100%;
    background: #fff;
    top: 0px;
    left: 0;
  }
  &.USD:before {content: '$'}
  &.CAN:before {content: 'C$'}
  &.ILS:before {content: '₪'}

  input[type='number'] {
    border: none;
    margin-left: 20px;
    box-shadow: none;
    width: calc(100% + 20px);
    font-size: 12px;
  }
  &:after {
    display: none !important;
  }
}
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    margin:0;
    input[type='number'] {
      background: #fff;
      margin-top: -15px;
    }
  }
}
table {
  border: 1px solid #efefef;
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: 10px;
}
table td {
  border-bottom: 1px solid #efefef;
  padding: 5px 12px;
}
table tr:last-child td {
  background: #f7f7f7;
  font-weight: bold;
}
::v-deep span.flex > span {
  display: flex;
}
.summary {
  margin-bottom: 20px;
}
</style>
